import ResumeCrafting from '../assets/ResumeCrafting.svg'
import ResumeTailoring from '../assets/ResumeTailoring.svg'
import ResumeDistribution from '../assets/ResumeDistribution.svg'
import CoverLetterCrafting from '../assets/CoverLetterCrafting.svg'
import JobsApplied from '../assets/JobsApplied.svg'
import JobSearchStrategy from '../assets/JobSearchStrategy.svg'
import InterviewsPracticed from '../assets/InterviewsPracticed.svg'
import QuestionsPracticed from '../assets/QuestionsPracticed.svg'
import InterviewStrategy from '../assets/InterviewStrategy.svg'
import InterviewsPassed from '../assets/InterviewsPassed.svg'
import First90DaysPlan from '../assets/First90DaysPlan.svg'
import GetPromotion from '../assets/GetPromotion.svg'
import ChangeCareers from '../assets/ChangeCareers.svg'

export const iconsMap: Record<string, React.FC<React.ComponentProps<'img'>>> = {
  ResumeCrafting: props => <img src={ResumeCrafting} {...props} />,
  ResumeTailoring: props => <img src={ResumeTailoring} {...props} />,
  ResumeDistribution: props => <img src={ResumeDistribution} {...props} />,
  CoverLetterCrafting: props => <img src={CoverLetterCrafting} {...props} />,
  JobsApplied: props => <img src={JobsApplied} {...props} />,
  JobSearchStrategy: props => <img src={JobSearchStrategy} {...props} />,
  InterviewsPracticed: props => <img src={InterviewsPracticed} {...props} />,
  QuestionsPracticed: props => <img src={QuestionsPracticed} {...props} />,
  InterviewStrategy: props => <img src={InterviewStrategy} {...props} />,
  InterviewsPassed: props => <img src={InterviewsPassed} {...props} />,
  First90DaysPlan: props => <img src={First90DaysPlan} {...props} />,
  GetPromotion: props => <img src={GetPromotion} {...props} />,
  ChangeCareers: props => <img src={ChangeCareers} {...props} />,
  _: props => <img src={ResumeCrafting} {...props} />,
}
